<template>
  <b-button
    v-b-tooltip.hover.top
    :title="content"
    class="button-tooltip"
  >
    {{titleContent}}
    <help-icon
      title="Ajuda"
      :size="questionSizeValue"
      v-if="question"
    />
  </b-button>
</template>

<script>
import HelpIcon from 'vue-material-design-icons/HelpCircle';

export default {
  name: 'Tooltip',
  components: {
    HelpIcon,
  },
  props: [
    'title',
    'content',
    'question',
    'questionSize',
  ],
  computed: {
    titleContent() {
      return this.question ? '' : this.title;
    },
    questionSizeValue() {
      return this.questionSize || 18;
    },
  },
};
</script>
